module.exports = __webpack_public_path__ + "img/c1.165dda79.png";